import { createContext } from "react";
const ManagerReportContext = createContext();
export default ManagerReportContext;
